import { ArrowUpRight } from "lucide-react";

export const ACM = () => {
  return (
    <section
      id="acm"
      className="scroll-mt-36 border-t border-[#DCDCD6] px-6 py-24 md:scroll-mt-24 md:py-32"
      data-testid="acm-section"
    >
      <div className="mx-auto max-w-4xl text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">
          Watch the Meeting
        </p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
          District #3 All-Candidates Meeting
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[#666666]">
          Recorded September 2026 — Joel and the other District 3 candidates
          answer residents' questions on transit, maintenance, housing, and the
          future of Collins-Bayridge.
        </p>
        <div className="mt-10 aspect-video w-full overflow-hidden border border-[#DCDCD6] bg-[#111111]">
          <iframe
            src="https://www.youtube-nocookie.com/embed/YBsgzpdKanc"
            title="Collins-Bayridge District All-Candidates Meeting — September 2026"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="h-full w-full"
            data-testid="acm-video"
          />
        </div>
        <a
          href="https://www.youtube.com/watch?v=YBsgzpdKanc"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="acm-youtube-link"
          className="group mt-6 inline-flex items-center gap-2 border-b border-[#111111] pb-1 text-xs font-semibold uppercase tracking-[0.2em] transition-colors duration-300 hover:text-[#666666]"
        >
          Watch on YouTube
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </section>
  );
};
